<template>
    <div class="form-constructor__edit">
        <div class="form-constructor__edit-name">
            <div class="form-field form-field--text" style="">
                <input id="form-name" v-model="formData.title_system" />
                <span
                    class="error"
                    style="left: 0"
                    v-if="errors.title_system"
                    >{{ errors.title_system }}</span
                >
            </div>
            <button class="btn btn-white" type="button" @click="onSaveForm">
                Save
            </button>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-4">
                <div class="form-field form-field--text">
                    <label>Page title</label>
                    <input id="form-title" v-model="formData.title" />
                    <span class="error" style="left: 0" v-if="errors.title">{{
                        errors.title
                    }}</span>
                </div>
            </div>
            <div class="col-lg-2 col-md-2">
                <div class="form-field form-field--text">
                    <label>Page amount</label>
                    <input
                        id="page-amount"
                        readonly
                        v-model="formData.pages.length"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div
                    class="form-field form-field--text form-field--url"
                    style="margin-bottom: 48px"
                >
                    <label
                        >Form url
                        <span
                            @click="openFormLink"
                            style="color: red; cursor: pointer"
                            ><i class="icon icon-external-link"></i></span
                    ></label>
                    <div class="row align-center">
                        <span>http://portal.theagencyguide.com/form/</span>
                        <input id="form-title" v-model="formData.url" />
                    </div>
                    <span class="error" style="left: 0" v-if="errors.url">{{
                        errors.url
                    }}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-4">
                <div class="form-field form-field--tree">
                    <label>New agency status</label>
                    <treeselect
                        v-model="formData.status"
                        :multiple="false"
                        :clearable="false"
                        :options="agency_statuses"
                    />
                    <span class="error" style="left: 0" v-if="errors.status">{{
                        errors.status
                    }}</span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4">
                <div class="form-field form-field--tree">
                    <label>New agency source</label>
                    <treeselect
                        v-model="formData.source"
                        :multiple="false"
                        :clearable="false"
                        :options="agency_sources"
                    />
                    <span class="error" style="left: 0" v-if="errors.status">{{
                        errors.source
                    }}</span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-constructor__edit-add-page">
                <button @click="addPage" type="button" class="btn btn--link">
                    Add page
                </button>
            </div>
        </div>

        <div class="row page-block-wrap">
            <div class="col-lg-6 col-md-6">
                <div
                    class="page-block"
                    v-for="(page, page_index) in formData.pages"
                >
                    <div class="row align-center">
                        <div class="page-block-title">
                            Page {{ page_index + 1 }}
                        </div>
                        <div class="controls">
                            <button
                                type="button"
                                @click="onAddField(page_index)"
                                class="btn btn--link"
                            >
                                Add field
                            </button>
                            <button
                                type="button"
                                class="btn btn--link"
                                @click="removePage(page_index)"
                            >
                                Remove page
                            </button>
                        </div>
                    </div>

                    <div class="page-block__fields">
                        <div
                            class="field"
                            v-for="(field, field_index) in page"
                            :key="field.id"
                        >
                            <div class="row align-center">
                                <div class="title">{{ field.title }}</div>
                                <div class="controls">
                                    <button
                                        type="button"
                                        @click="
                                            onEditField(page_index, field.id)
                                        "
                                        class="btn btn--link"
                                    >
                                        Update
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn--link"
                                        @click="
                                            removeField(page_index, field.id)
                                        "
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                            <div class="field-item">
                                <div class="label">Portal field:</div>
                                <div class="value">
                                    {{ getPortalFieldName(field.widget.id) }}
                                </div>
                            </div>
                            <div class="field-item">
                                <div class="label">Mandatory:</div>
                                <div class="value">
                                    <div class="checkbox">
                                        <div class="form-field checkbox-wrap">
                                            <input
                                                type="checkbox"
                                                :id="`mandatory_${field.id}`"
                                                :checked="field.required"
                                                disabled
                                            />
                                            <label
                                                :for="`mandatory_${field.id}`"
                                            >
                                                <i
                                                    class="icon icon-checkmark"
                                                ></i>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field-item">
                                <div class="label">Other value:</div>
                                <div class="value">
                                    <div class="value">
                                        <div class="checkbox">
                                            <div
                                                class="form-field checkbox-wrap"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :id="`other_${field.id}`"
                                                    :checked="field.custom"
                                                    disabled
                                                />
                                                <label
                                                    :for="`other_${field.id}`"
                                                >
                                                    <i
                                                        class="icon icon-checkmark"
                                                    ></i>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field-item">
                                <div class="label">
                                    "Not applicable" option:
                                </div>
                                <div class="value">
                                    <div class="checkbox">
                                        <div class="form-field checkbox-wrap">
                                            <input
                                                type="checkbox"
                                                :id="`not_applicable_${field.id}`"
                                                :checked="field.not_applicable"
                                                disabled
                                            />
                                            <label
                                                :for="`not_applicable_${field.id}`"
                                            >
                                                <i
                                                    class="icon icon-checkmark"
                                                ></i>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field-item" v-if="field.limit">
                                <div class="label">Limit:</div>
                                <div class="value">
                                    {{ field.limit }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <field-modal
            v-if="isOpenModal"
            :page="modalSettings.page"
            :onAdd="addNewField"
            :onEdit="editField"
            :editData="modalSettings.editData"
            :onClose="toggleModal"
            :portal_fields_list="portal_fields_options"
        ></field-modal>
    </div>
</template>

<script>
import FieldModal from "./Modal.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "axios";

export default {
    name: "Form_Constructor",
    components: {
        Treeselect,
        FieldModal,
    },
    props: ["onAfterSave", "portal_fields", "editData", "sources", "statuses"],
    data() {
        return {
            title: "",
            url: "",
            page_count: 0,
            status: null,
            agency_statuses: [
                {id: 1, label: "Active"},
                {id: 2, label: "Inactive"},
            ],

            agency_sources: [
                { id: 1, label: "New agency form" },
                { id: 2, label: "Podcast guest form" },
                { id: 3, label: "Waitlist form" },
                { id: 4, label: "Manual" },
            ],

            modalSettings: {
                page: null,
                editData: null,
            },

            portal_fields_options: [
                {
                    id: 1,
                    label: "Agency.Name",
                },
                {
                    id: 2,
                    label: "Agency.Website",
                },
                {
                    id: 3,
                    label: "Agency.Locations",
                },
                {
                    id: 4,
                    label: "Agency.HQ.Address",
                },
                {
                    id: 5,
                    label: "Agency.Main-contact.Email",
                },
            ],

            formData: {
                title_system: "New form",
                title: "New form",
                url: "",
                status: null,
                source: null,
                pages: [],
            },

            errors: {
                title_system: null,
                status: null,
                url: null,
                title: null,
                source: null,
            },

            isOpenModal: false,
        };
    },
    mounted() {
        this.agency_sources = this.sources;
        this.agency_statuses = this.statuses;
        this.portal_fields_options = JSON.parse(this.portal_fields);
        if (this.editData) {
            this.formData = this.editData;

            if (this.editData.title_system) {
                this.formData.title_system = this.editData.title_system;
            } else if (this.editData.title) {
                this.formData.title_system = this.editData.title;
            }
        }
    },
    methods: {
        toggleModal() {
            this.isOpenModal = !this.isOpenModal;
        },
        getPortalFieldName(name_portal_field = null) {
            if (!name_portal_field) {
                return "";
            }

            const _portal_field = this.portal_fields_options.find(
                (p) => p.id === name_portal_field
            );

            if (!_portal_field) {
                return "";
            }

            return _portal_field.label;
        },
        addPage() {
            this.formData.pages.push([]);

            this.$forceUpdate();
        },
        removePage(index) {
            this.formData.pages.splice(index, 1);
            this.$forceUpdate();
        },

        onAddField(page) {
            this.modalSettings.page = page;
            this.isOpenModal = true;
        },

        addNewField(page, data) {
            this.formData.pages[page].push(data);
            this.isOpenModal = false;
        },

        removeField(page, id) {
            this.formData.pages[page] = this.formData.pages[page].filter(
                (f) => f.id !== id
            );

            this.$forceUpdate();
        },

        onEditField(page, field_id) {
            const editData = this.formData.pages[page].find(
                (f) => f.id === field_id
            );
            this.modalSettings.page = page;
            this.modalSettings.editData = editData;
            this.isOpenModal = true;
        },

        editField(page, data) {
            const index = this.formData.pages[page].findIndex(
                (f) => f.id === data.id
            );
            this.formData.pages[page][index] = data;

            this.isOpenModal = false;
            this.modalSettings.page = null;
            this.modalSettings.editData = null;

            this.$forceUpdate();
        },

        onChangeMandatory(checked = false, field_id = null, page = 0) {
            if (!field_id) {
                return;
            }

            const index = this.formData.pages[page].fields.findIndex(
                (f) => f.id === field_id
            );
            this.formData.pages[page].fields[index].required = checked;

            this.$forceUpdate();
        },

        onChangeOther(checked = false, field_id = null, page = 0) {
            if (!field_id) {
                return;
            }

            const index = this.formData.pages[page].fields.findIndex(
                (f) => f.id === field_id
            );

            this.formData.pages[page].fields[index].other = checked;

            this.$forceUpdate();
        },

        formatData() {
            const __data = {};

            __data.id = this.formData.id;
            __data.title_system = this.formData.title_system;
            __data.title = this.formData.title;
            __data.url = this.formData.url;
            __data.status = this.formData.status;
            __data.source = this.formData.source;
            __data.fields = [];

            this.formData.pages.forEach((page, index) => {
                if (page.length) {
                    page.forEach((field) => {
                        delete field.id;

                        __data.fields.push({
                            ...field,
                            page: index + 1,
                        });
                    });
                }
            });

            return __data;
        },

        async onSaveForm() {
            this.onValidationForm();

            if (!this.onCheckIsHasNameAndEmail()) {
                this.$toast.error("Agency name and email are required fields");
                return;
            }

            if (
                this.errors.source ||
                this.errors.status ||
                this.errors.title ||
                this.errors.url ||
                this.errors.title_system
            ) {
                return;
            }

            const data = this.formatData();
            try {
                await axios
                    .post("/admin-panel/forms/store", data)
                    .then(() => {
                        this.onAfterSave();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            } catch (err) {
                console.error("onSaveForm error", err);
            }
        },

        onValidationForm() {
            this.errors.source = null;
            this.errors.status = null;
            this.errors.url = null;
            this.errors.title = null;
            this.errors.title_system = null;

            if (!this.formData.url) {
                this.errors.url = "Required";
            }
            if (!this.formData.source) {
                this.errors.source = "Required";
            }
            if (!this.formData.status) {
                this.errors.status = "Required";
            }
            if (!this.formData.title) {
                this.errors.title = "Required";
            }
            if (!this.formData.title_system) {
                this.errors.title_system = "Required";
            }
        },

        onCheckIsHasNameAndEmail() {
            let isHasEmail = false,
                isHasName = false;

            console.log(this.formData.pages);

            if (this.formData.pages.length >= 1) {
                this.formData.pages.forEach((page) => {
                    if (
                        page.some((f) => f.widget.key === "email" && f.required)
                    ) {
                        isHasEmail = true;
                    }

                    if (
                        page.some((f) => f.widget.key === "name" && f.required)
                    ) {
                        isHasName = true;
                    }
                });
            }

            return isHasEmail && isHasName;
        },

        openFormLink() {
            const _form_link = `/form/${this.formData.url}`;

            if (this.formData.url) {
                window.open(_form_link, "_blank");
            }
        },
    },
};
</script>
